import React, { Component, useState, useEffect } from 'react';
import {
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Table,
    Row,
    Col,
    Button
} from "reactstrap";
import MaterialTable, { MTableToolbar } from "material-table";
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import Modal from 'react-bootstrap/Modal';
import Spinner from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';

import { isExpired, decodeToken } from "react-jwt";
import { unregister } from "../Interceptor.js";

const tableIcons = {
    Add: React.forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: React.forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: React.forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: React.forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: React.forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: React.forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: React.forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: React.forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: React.forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: React.forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: React.forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: React.forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: React.forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: React.forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: React.forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: React.forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: React.forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

var comprobantes = [{}]

function Comprobantes() {
    const [loading, setLoading] = React.useState(false);

    useEffect(() => {
        var token = localStorage.getItem('token');
        var isMyTokenExpired = isExpired(token);
        var token = localStorage.setItem("tokenValidate", isMyTokenExpired);
        
        if (isMyTokenExpired) {
            window.location = "/"
        }
        login();
    }, []);


    const [comprobantesDatos, setComprobantesDatos] = React.useState(comprobantes);
    const [show, setShow] = React.useState(false);
    const [rutaPdf, setPDF] = React.useState("");

    const login = () => {

        var myHeaders = new Headers();

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };
        setLoading(true);

        const apiUrl = './api/Documento/TraerDatosDocumentos?IdAmbiente=' + '1';
        console.log(apiUrl);
        fetch(apiUrl, requestOptions)
            .then(response => response.json())
            .then(

                data => {
                    let ListComprobantes = [];
                    console.log(data);

                   comprobantes = data.basePresentation;
                    ListComprobantes= data.basePresentationList;
                    
                   // setComprobantesDatos([comprobantes]);
                    setComprobantesDatos(ListComprobantes);

                    setLoading(false);
                }

            )
            .catch(error => {
                console.log('error', error);

            }
            )
    }

    const clickpdf = (e) => {
        //setShow(true);
        
        var rutapdfp = e.RutaPDF;
        var rutaa = rutapdfp.replace("http", "https");
        setPDF(rutaa);
        localStorage.setItem("pdf", rutaa);
        localStorage.setItem("Id_CFD", e.Id_CFD);
        localStorage.setItem("datosDocumentos", JSON.stringify(e));
        window.location = "/admin/comprobante"
    }

   

    return (
        <>
            

            <div className="content">
                <Dialog open={loading} >
                    <div style={{ textAlign: "center", margin: "15px" }}>
                        {loading && <Spinner color="secondary" />}
                        <h3 style={{ fontSize: '15px', fontFamily: 'Hammersmith One' }}>Cargando...</h3>
                    </div>
                </Dialog>
                <Modal
                    show={show}
                    onHide={() => { setShow(false); }}
                    style={{ fontFamily: 'Hammersmith One'}}
                    size="lg"
                    aria-labelledby="example-modal-sizes-title-lg"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Detalle Comprobante</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <object data={rutaPdf} type="application/pdf" width="100%" height="900px">
                        </object>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => { setShow(false); }} style={{ fontFamily: 'Hammersmith One' }}>
                            Cerrar
                      </Button>
                    </Modal.Footer>
                </Modal>
                <Row>
                    <Col md="12">
                        <Card>
                            
                            <CardBody>
                                <MaterialTable
                                    columns={[
                                        {
                                            title: "ID",
                                            field: "Id_CFD",
                                            type: "string",
                                            filtering: true
                                        },
                                        {
                                            title: "Empleado",
                                            field: "NombreCliente",
                                            type: "string",
                                            filtering: true
                                        },
                                        {
                                            title: "Identificacion",
                                            field: "NitCliente",
                                            type: "string",
                                            filtering: true
                                        }
                                        ,
                                        {
                                            title: "Fecha Expedicion",
                                            field: "FechaExpedicion",
                                            type: "date",
                                            filtering: true
                                        }
                                        ,
                                        {
                                            title: "Estado Tramite",
                                            field: "EstadoTramite",
                                            type: "string",
                                            filtering: true
                                        },
                                        {
                                            title: "Estado Dian",
                                            field: "EstadoDian",
                                            type: "string",
                                            filtering: true
                                        }
                                    ]}

                                    data={comprobantesDatos}
                                    title="Comprobantes"
                                    onSelectionChange={(newSelection) => {

                                    }}
                                    icons={tableIcons}
                                    actions={[
                                        {
                                            icon: () => <PictureAsPdfIcon />,
                                            tooltip: "ver pdf",
                                            title: "Ver pdf",
                                            onClick: (event, rowData) => { clickpdf(rowData); },
                                            position: "row"
                                        }
                                    ]}
                                    options={{
                                        filtering: true,
                                        selection: true,
                                        exportButton: true,
                                        exportAllData: true,
                                        maxBodyHeight: '800px'
                                    }}
                                    style={{ fontFamily: 'Hammersmith One'}}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                    
                </Row>
            </div>
        </>
    );
}

export default Comprobantes;
